import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/personType";
export default class PersonTypeService {
    static searchPersonType() {
        return FetchService.getPagedResponse(BASE_URL + "/search", {});
    }
    static search(search) {
        return FetchService.getSingleResponse(BASE_URL + "/search", Object.assign({}, search));
    }
    static searchAll(search) {
        return FetchService.getSingleResponse(BASE_URL + "/search", Object.assign({}, search));
    }
    static getPersonTypesForApp(virtualizedApp) {
        return FetchService.getSingleResponse("/aviso/VirtualizedApp/getPersonTypesForVirtualizedApp", { virtualizedApp });
    }
    static getPersonTypesForPerson(affiliationId) {
        return FetchService.getSingleResponse(BASE_URL + "/getPersonTypesForPerson", { affiliationId });
    }
    static getAppPersonTypesForPeople(personIds) {
        return FetchService.getSingleResponse(BASE_URL + "/getAppPersonTypesForPeople", { personIds });
    }
    static getPersonTypesForFindPath(findPath, virtualizedAppName, studentId, tabId) {
        return FetchService.getSingleResponse("/aviso/PersonType/getPersonTypesForFindPath", { findPath, virtualizedAppName, studentId, tabId });
    }
}
